import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1923 3.8053C10.1923 3.97146 10.1323 4.11407 10.0123 4.23315L6.92646 7.29499C6.81615 7.4113 6.674 7.46899 6.50046 7.46899C6.32969 7.46899 6.18569 7.4113 6.06892 7.29499L2.98308 4.23315C2.86631 4.11084 2.80769 3.96822 2.80769 3.8053C2.80769 3.64515 2.86631 3.50392 2.98308 3.38161L3.33892 3.02899C3.45892 2.90992 3.60246 2.85038 3.77 2.85038C3.93754 2.85038 4.08108 2.90992 4.20154 3.02899L5.59031 4.40715V1.09607C5.59031 0.932687 5.64938 0.800687 5.76754 0.698225C5.88615 0.596687 6.02969 0.545456 6.19677 0.545456H6.80323C6.97077 0.545456 7.11385 0.596687 7.23246 0.698225C7.35062 0.800687 7.41015 0.932687 7.41015 1.09607V4.40715L8.80354 3.02899C8.91708 2.90992 9.05969 2.85038 9.23 2.85038C9.40077 2.85038 9.54292 2.90992 9.65646 3.02899L10.0123 3.38161C10.1323 3.50115 10.1923 3.64192 10.1923 3.8053Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.34615 9.31515H10.6538V7.46899C10.6538 7.21422 10.8606 7.00746 11.1154 7.00746H12.0385C12.2932 7.00746 12.5 7.21422 12.5 7.46899V10.6998C12.5 10.9545 12.2932 11.1613 12.0385 11.1613H0.961538C0.706769 11.1613 0.5 10.9545 0.5 10.6998V7.46899C0.5 7.21422 0.706769 7.00746 0.961538 7.00746H1.88462C2.13938 7.00746 2.34615 7.21422 2.34615 7.46899V9.31515Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgDownloadWhite);
export { ForwardRef as ReactComponent };
